import { render } from "./PaginationModal.vue?vue&type=template&id=311786d1"
import script from "./PaginationModal.vue?vue&type=script&lang=js"
export * from "./PaginationModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/niq/Documents/Project Apps/TMI/Helpdesk App/apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__